module.exports = __webpack_public_path__ + "media/images/official/kv_sp1-ccdf072b94f994ef5db8874d4f7e526b.webp";